import { createTheme } from '@material-ui/core/styles'
import { rgb } from 'polished'

export const typography = {
  h1: {
    fontSize: '3rem',
    fontFamily: 'Source Serif Pro',
    fontWeight: 600,
    lineHeight: '3.375rem',
    textTransform: 'capitalize',
    letterSpacing: '0.15rem'
  },
  h2: {
    fontSize: '2rem',
    fontFamily: 'Source Serif Pro',
    fontWeight: 600,
    lineHeight: '2.375rem',
    textTransform: 'capitalize',
    letterSpacing: '0.15rem'
  },
  h3: {
    fontSize: '1.375rem',
    fontFamily: 'Roboto',
    fontWeight: 700,
    lineHeight: '1.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.041rem'
  },
  h4: {
    fontSize: '1.125rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '1.5rem',
    textTransform: 'capitalize',
    letterSpacing: '0.023rem'
  },
  h5: {
    fontSize: '1rem',
    fontFamily: 'Roboto',
    fontWeight: 400,
    lineHeight: '1.5rem',
    textTransform: 'capitalize',
    letterSpacing: '0.023rem'
  },
  h6: {
    fontSize: '0.875rem',
    fontFamily: 'Roboto',
    fontWeight: 600,
    lineHeight: '1.25rem',
    textTransform: 'uppercase',
    letterSpacing: '0.023rem'
  },
  subtitle1: {
    fontSize: '0.75rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '0rem'
  },
  subtitle2: {
    fontSize: '0.625rem',
    fontFamily: 'Roboto',
    fontWeight: 600,
    lineHeight: '0.688rem',
    textTransform: 'uppercase',
    letterSpacing: '0rem'
  },
  body1: {
    fontSize: '0.875rem',
    fontFamily: 'Roboto',
    fontWeight: 400,
    lineHeight: '1.25rem',
    textTransform: 'none',
    letterSpacing: '0rem'
  },
  body2: {
    fontSize: '0.625rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '0.688rem',
    textTransform: 'none',
    letterSpacing: '0rem'
  },
  // body3: {
  //   fontSize: '0.625rem',
  //   fontFamily: 'Roboto',
  //   fontWeight: 500,
  //   lineHeight: '0.688rem',
  //   textTransform: 'none',
  //   letterSpacing: '0rem'
  // },
  // label: {
  //   fontSize: '0.625rem',
  //   fontFamily: 'Roboto',
  //   fontWeight: 600,
  //   lineHeight: '0.688rem',
  //   textTransform: 'uppercase',
  //   letterSpacing: '0rem'
  // },
  caption: {
    fontSize: '0.75rem',
    fontFamily: 'Roboto',
    fontWeight: 400,
    lineHeight: '1rem',
    textTransform: 'none',
    letterSpacing: '0rem'
  },
  button: {
    fontSize: '0.875rem',
    fontFamily: 'Roboto',
    fontWeight: 600,
    lineHeight: '1.25rem',
    textTransform: 'uppercase',
    letterSpacing: '0.023rem'
  },
  overline: {
    fontSize: '0.625rem',
    fontFamily: 'Roboto',
    fontWeight: 600,
    lineHeight: '0.688rem',
    textTransform: 'uppercase',
    letterSpacing: '0rem'
  }
}
export const lightPalette = {
  type: 'light',
  primary: {
    main: '#444444',
    light: '#777777',
    dark: '#000000',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#000000',
    light: '#333333',
    dark: '#000000',
    contrastText: '#FFFFFF'
  },
  error: {
    main: '#D90000',
    light: '#E03333',
    dark: '#970000',
    contrastText: '#FFFFFF'
  },
  warning: {
    main: '#FFC700',
    light: '#FFD233',
    dark: '#B28B00',
    contrastText: '#000000'
  },
  info: {
    main: '#3B6DE3',
    light: '#628AE8',
    dark: '#294C9E',
    contrastText: '#FFFFFF'
  },
  success: {
    main: '#008A35',
    light: '#33A15D',
    dark: '#006025',
    contrastText: '#FFFFFF'
  },
  text: {
    primary: '#444444',
    secondary: '#000000',
    disabled: '#CCCCCC',
    hint: '#999999'
  },
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF'
  }
}
export const darkPalette = {
  type: 'dark',
  primary: {
    main: '#fff',
    contrastText: '#000'
  },
  secondary: {
    main: '#aaa',
    contrastText: '#333'
  },
  warning: {
    main: '#ff9800',
    light: rgb(255, 172, 51),
    dark: rgb(178, 106, 0),
    contrastText: '#fff'
  },
  info: {
    main: '#2196f3',
    light: rgb(91, 154, 255),
    dark: rgb(0, 82, 204),
    contrastText: '#fff'
  },
  success: {
    main: '#4caf50',
    light: rgb(111, 191, 115),
    dark: rgb(53, 122, 56),
    contrastText: '#fff'
  }
}
export const lightTheme = createTheme({
  palette: lightPalette,
  typography,
  spacing: 4,
  props: {
    MuiAppBar: {
      color: 'inherit'
    }
  },
  shape: {
    borderRadius: 0
  },
  overrides: {
    MuiButton: {
      textPrimary: {
        color: lightPalette.info.main,
        backgroundColor: '#ffffff',
        '&:hover': {
          color: lightPalette.info.dark,
          backgroundColor: '#ffffff'
        }
      }
    }
  }
} as any)
export const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  spacing: 4,
  props: {
    MuiAppBar: {
      color: 'inherit'
    }
  },
  shape: {
    borderRadius: 0
  },
  overrides: {
    MuiButton: {
      textPrimary: {
        color: darkPalette.info.main,
        backgroundColor: '#000000',
        '&:hover': {
          color: darkPalette.info.dark,
          backgroundColor: '#000000'
        }
      }
    }
  }
} as any)
